import { ChevronLeft, Menu } from '@material-ui/icons';
import { Drawer, IconButton, Hidden } from '@material-ui/core';
import React from 'react';
import styled from 'styled-components';

import Container from './components/Container';

const CustomDrawerSmall = styled(Drawer)`
  &&& {
    & > div {
      min-height: 100%;
      width: 30%;
      min-width: 27rem;
    }
  }
`;
const CustomDrawerLarge = styled(Drawer)`
  &&& {
    height: 100%;
    & > div {
      // height: 100vh;
      min-width: 28rem;
      width: 30vw;
      position: relative !important;
    }
  }
`;
const DrawerMenu = styled.div`
  display: flex;
  margin-top: 5rem;
  min-height: 3rem;
  justify-content: flex-end;
`;

const CustomCloseButton = styled(IconButton)`
  &&& {
    position: absolute;
    right: 1rem;
    top: 1rem;
    z-index: 999;
  }
`;
const CustomOpenButton = styled(IconButton)`
  &&& {
    display: flex;
    align-items: center;
    position: absolute;
    top: 0.5rem;
    left: 1rem;
    z-index: 1501;

    & svg {
      fill: #fff;
    }
  }
`;

class Sidebar extends React.PureComponent {
  state = {
    sidebarVisible: false,
  };

  onSidebarToggle = () => {
    this.setState(state => ({
      sidebarVisible: !state.sidebarVisible,
    }));
  };

  render() {
    return (
      <React.Fragment>
        <Hidden lgUp>
          {this.state.sidebarVisible === false && (
            <CustomOpenButton onClick={this.onSidebarToggle}>
              <Menu color="primary" />
            </CustomOpenButton>
          )}
        </Hidden>
        <CustomDrawerSmall
          variant="temporary"
          anchor="left"
          open={this.state.sidebarVisible}
          onClose={this.onSidebarToggle}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
        >
          <DrawerMenu>
            <CustomCloseButton onClick={this.onSidebarToggle}>
              <ChevronLeft />
            </CustomCloseButton>
          </DrawerMenu>
          <Container>{this.props.children}</Container>
        </CustomDrawerSmall>
        <Hidden mdDown implementation="css">
          <CustomDrawerLarge variant="permanent" open>
            <Container>{this.props.children}</Container>
          </CustomDrawerLarge>
        </Hidden>
      </React.Fragment>
    );
  }
}

export default Sidebar;
